import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostZeitArtCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostZeitArtCommandService],
  exports: []
})
export class PostZeitArtCommandServiceModule { }
